(() => {
  class SolviSurprise {
    constructor(root) {
      if (!root || root.dataset.solviSurpriseReady === 'true') return;
      root.dataset.solviSurpriseReady = 'true';

      this.root = root;
      this.form = root.querySelector('[data-solvi-surprise-form]');
      this.groups = Array.from(root.querySelectorAll('[data-solvi-surprise-group]'));
      this.submit = root.querySelector('[data-solvi-surprise-submit]');
      this.notes = root.querySelector('[data-solvi-surprise-notes]');
      this.error = root.querySelector('[data-solvi-surprise-error]');
      this.announcement = root.querySelector('[data-solvi-surprise-announcement]');
      this.baseConfigured = root.dataset.baseConfigured === 'true';
      this.baseAvailable = root.dataset.baseAvailable === 'true';
      this.variantId = Number.parseInt(root.dataset.variantId, 10);
      this.cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
      this.cartUrl = root.dataset.cartUrl || '/cart';
      this.buttonText = root.dataset.buttonText || 'surprise me';

      this.bindEvents();
    }

    bindEvents() {
      this.groups.forEach((group) => {
        group.querySelectorAll('[data-solvi-surprise-option]').forEach((option) => {
          option.addEventListener('click', () => this.toggleOption(group, option));
        });
      });

      this.form?.addEventListener('submit', (event) => this.submitForm(event));
    }

    toggleOption(group, option) {
      const isSelected = option.getAttribute('aria-pressed') === 'true';

      if (group.dataset.mode === 'single') {
        group.querySelectorAll('[data-solvi-surprise-option]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      }

      option.setAttribute('aria-pressed', String(!isSelected));
      this.updateProperty(group);

      const action = !isSelected ? 'selected' : 'removed';
      this.announce(`${option.dataset.value} ${action}.`);
    }

    updateProperty(group) {
      const property = group.querySelector('[data-solvi-surprise-property]');
      const selected = Array.from(group.querySelectorAll('[data-solvi-surprise-option][aria-pressed="true"]'))
        .map((option) => option.dataset.value)
        .filter(Boolean);

      if (!property) return;
      property.value = selected.join(', ');
      property.disabled = selected.length === 0;
    }

    getProperties() {
      const properties = {};

      this.root.querySelectorAll('[data-solvi-surprise-property]').forEach((input) => {
        if (!input.disabled && input.value.trim()) {
          const match = input.name.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = input.value.trim();
        }
      });

      const notes = this.notes?.value.trim();
      if (notes) properties['Notes for Solvi'] = notes;
      return properties;
    }

    async submitForm(event) {
      event.preventDefault();
      this.hideError();

      if (!this.baseConfigured || !this.baseAvailable || !this.variantId) {
        this.showError(this.baseConfigured
          ? 'This Solvi Surprise product is unavailable right now.'
          : 'Please select a Solvi Surprise product in the section settings.');
        return;
      }

      this.setBusy(true);

      try {
        const response = await fetch(this.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: this.variantId,
              quantity: 1,
              properties: this.getProperties()
            }]
          })
        });

        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(this.cartUrl);
      } catch (error) {
        this.showError('We couldn’t add this to cart. Please try again.');
        this.setBusy(false);
      }
    }

    setBusy(isBusy) {
      if (!this.submit) return;
      this.submit.disabled = isBusy || !this.baseAvailable;
      this.submit.textContent = isBusy ? 'adding your surprise…' : this.buttonText;
      this.submit.setAttribute('aria-busy', String(isBusy));
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = false;
      this.error.focus?.();
    }

    hideError() {
      if (this.error) this.error.hidden = true;
    }

    announce(message) {
      if (!this.announcement) return;
      this.announcement.textContent = '';
      window.requestAnimationFrame(() => { this.announcement.textContent = message; });
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-solvi-surprise]').forEach((root) => new SolviSurprise(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
